module.exports = __webpack_public_path__ + "img/Pregnancy.1b2a2d49.png";